import { FieldHookConfig, useField } from "formik";

import { Checkbox } from "@sso/components/Form";

export const FormikCheckbox = (props: FieldHookConfig<string> & { label: string }) => {
  const [field, meta] = useField({ ...props, type: "checkbox" });

  const err = Boolean(meta.touched && meta.error);
  return <Checkbox id={props.name} {...field} {...props} error={err} errorText={err ? meta.error : null} />;
};
